import axios from "axios";

const apiInvoice = axios.create({
  baseURL: process.env.REACT_APP_BOVEXO_INVOICE_URL,
  validateStatus: (status) => status >= 200 && status < 300,
  // baseURL: "http://localhost:8072",
});

export default apiInvoice;
